import { render } from "./TallPage.vue?vue&type=template&id=75c42f46&scoped=true"
import script from "./TallPage.vue?vue&type=script&lang=js"
export * from "./TallPage.vue?vue&type=script&lang=js"

import "./TallPage.vue?vue&type=style&index=0&id=75c42f46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c42f46"]])

export default __exports__